import { Header } from "@/components/Header";
import MyRewardsSection from "@/components/MyRewardsSection";

/**
 * "My Vouchers" — dedicated page hosting the MyRewardsSection card that
 * previously lived at the bottom of `/settings`. Split out in iter103 so
 * winners can jump straight to their prize codes / QR without scrolling
 * past preference toggles. Same URL shape as every other player-facing
 * page: master path `/my-vouchers` (Super-Admin only per iter99 lockdown)
 * and per-tenant path `/c/[slug]/my-vouchers` (all authenticated pub
 * members).
 */
export default function MyVouchersPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main
        className="max-w-3xl mx-auto px-6 sm:px-10 py-8 sm:py-10 space-y-8"
        data-testid="my-vouchers-page"
      >
        <header className="pb-4 border-b border-zinc-200">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-zinc-500">
            Prizes
          </p>
          <h1 className="mt-1 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-zinc-950">
            My vouchers
          </h1>
          <p className="mt-2 text-sm text-zinc-600 max-w-xl">
            Every voucher you&apos;ve won from a closed season. Show the QR
            to the sponsor to redeem.
          </p>
        </header>
        <MyRewardsSection />
      </main>
    </div>
  );
}
